/**
 * @file src/api/creditNote.api.js
 * @description Credit note API calls.
 *
 * Current state:
 *  - Backend endpoints not yet implemented
 *  - Returning mock data so the UI can be built
 *  - When backend is ready, replace mock returns with apiClient calls
 *    (the function signatures and return shapes stay the same)
 *
 * Future endpoints (assumed):
 *  GET    /credit-notes/         → list credit notes for the company
 *  POST   /credit-notes/         → create a credit note
 *  PUT    /credit-notes/:id      → update a credit note
 *  DELETE /credit-notes/:id      → delete a credit note
 *
 * Rules:
 *  - No try/catch — ApiError propagates from lib/axios.js interceptor
 *  - No console.log
 *  - No React, no hooks, no state
 */

// import { apiClient } from "lib/axios";

// ---------------------------------------------------------------------------
// Reads
// ---------------------------------------------------------------------------

/**
 * Fetch all credit notes for the current company.
 *
 * TEMPORARY: returns mock data while backend is unimplemented.
 * Replace with: const { data } = await apiClient.get("/credit-notes/");
 *
 * @returns {Promise<{ creditNotes: object[] }>}
 */
export const getCreditNotes = async () => {
  return {
    creditNotes: [
      {
        id: "1",
        clientName: "Ahmed Al-Rashid",
        invoiceNumber: "INV-0021",
        creditNoteNumber: "CN-0001",
        date: "2025-01-20",
        amount: 2000.0,
        taxRate: 15,
        reason: "Goods returned — damaged on delivery",
        status: "submitted",
      },
      {
        id: "2",
        clientName: "Global Tech Solutions",
        invoiceNumber: "INV-0019",
        creditNoteNumber: "CN-0002",
        date: "2025-02-08",
        amount: 5000.0,
        taxRate: 15,
        reason: "Service level agreement not met",
        status: "issued",
      },
      {
        id: "3",
        clientName: "Sara Al-Mansoori",
        invoiceNumber: "INV-0030",
        creditNoteNumber: "CN-0003",
        date: "2025-02-20",
        amount: 750.0,
        taxRate: 0,
        reason: "Billing correction — zero-rated item",
        status: "draft",
      },
    ],
  };
};